import { WarrantyLogService } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const warrantyTypesQueryKey = 'warrantyTypesQueryKey';

export const useWarrantyTypes = <TQueryKey extends Array<unknown> = unknown[]>(
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof WarrantyLogService.getWarrantyLogWarrantyTypes>>,
      QueryError,
      Awaited<ReturnType<typeof WarrantyLogService.getWarrantyLogWarrantyTypes>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery(
    [warrantyTypesQueryKey, ...(queryKey ?? [])],
    () => WarrantyLogService.getWarrantyLogWarrantyTypes(),
    options
  );
